import { Box, Container, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  getBeneficiaryBenefits,
  getBenefitBeneficiarySummary,
} from './APIs/action';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BenefitTable from './Component/BenefitTable';
import { Spin } from 'antd';

const BeneficiarySummary = () => {
  const [benefitsData, setBenefitsData] = useState({});
  const [beneficiaryData, setBeneficiaryData] = useState();
  const [loader, setLoader] = useState(false);
  const fetchAvailableBenefit = async () => {
    setLoader(true);
    const { error, message, data } = await getBeneficiaryBenefits();
    if (!error && Object.keys(data).length > 0) {
      setBenefitsData(data);
      setLoader(false);
      return;
    } else {
      toast.error('No benefits available');
    }
  };
  useEffect(() => {
    fetchAvailableBenefit();
  }, []);
  const getBenefitBeneficiaryData = async () => {
    const { error, message, data } = await getBenefitBeneficiarySummary();
    if (!error && Object.keys(data).length > 0) {
      setBeneficiaryData(data);
    } else {
      toast.error('No Beneficiary details available');
      setBeneficiaryData([]);
    }
  };
  useEffect(() => {
    getBenefitBeneficiaryData();
  }, []);
  return (
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '5rem',
          height: window.innerHeight,
          overflowY: 'auto',
        }}
      >
        {benefitsData && Object.keys(benefitsData).length > 0 ? (
          beneficiaryData === undefined ? (
            <Spin spinning={true}>Loading Beneficiary Details...</Spin>
          ) : Object.keys(beneficiaryData).length > 0 ? (
            <>
              <Typography
                variant='h4'
                sx={{ mb: '2rem' }}
              >
                Beneficiary Details
              </Typography>
              <Box>
                <BenefitTable
                  getBenefitBeneficiaryData={getBenefitBeneficiaryData}
                  data={beneficiaryData}
                />
              </Box>
            </>
          ) : (
            <Typography
              sx={{
                color: '#af6a0e',
                fontWeight: 'bold',
                fontSize: '1.5rem',
              }}
            >
              Currently no Beneficiary details available
            </Typography>
          )
        ) : (
          <Typography
            sx={{
              color: '#af6a0e',
              fontWeight: 'bold',
              fontSize: '1.5rem',
            }}
          >
            No Beneficiary Details added
          </Typography>
        )}
      </Container>
  );
};

export default BeneficiarySummary;
